import PropTypes from 'prop-types'

export default PropTypes.shape({
  count: PropTypes.number.isRequired,
  rating: PropTypes.number.isRequired,
  star_rating: PropTypes.number.isRequired
})
